import { TFunction } from 'i18next'
import camelCase from 'camelcase'

import { EnergyCertificateAvailability } from '../../@types/radio-types'

export const getEnergyCertificateLabels = (t: TFunction) =>
  Object.keys(EnergyCertificateAvailability).map((key) => ({
    radioId: key,
    type: key,
    label: t(`wizard.screen.construction.energyCertificateType.${camelCase(key)}`, key),
  }))
